import gql from "graphql-tag"

export default gql`
  mutation importDelete($importId: String!) {
    importDelete(importId: $importId)
  }
`